import React from 'react';
import { Icon } from 'antd';
import { ReactComponent as CashPaymentIcon } from '../../../../../resource/PaymentInCashIcon.svg';
import { ReactComponent as InvoicePaymentIcon } from '../../../../../resource/InvoiceIcon.svg';
import { paymentTypeKeys, paymentTypeById } from '../../config/paymentTypes';
import styles from './InvoiceBlock.module.scss';

const IconFactory = ({ paymentTypeId, ...props }) => {
  const type = paymentTypeById[paymentTypeId];

  if (!type) return null;

  switch (type) {
    case paymentTypeKeys.card:
      return (
        <Icon
          {...props}
          style={{ fontSize: '18px' }}
          type="credit-card"
        />
      );

    case paymentTypeKeys.cash:
      return (
        <Icon
          {...props}
          className={styles.icon}
          component={CashPaymentIcon}
        />
      );

    case paymentTypeKeys.invoice:
      return (
        <Icon
          {...props}
          className={styles.icon}
          component={InvoicePaymentIcon}
        />
      );

    default:
      return null;
  }
};

export default IconFactory;
